/**
 * Преобразует элементы с data-offer-click в ссылки
 * @param container - контейнер для поиска элементов
 */
export function convertOfferClickToLink(container: Document | Element = document): HTMLAnchorElement[] {
  const elements = Array.from(container.querySelectorAll<HTMLDivElement>('[data-offer-click]'));

  const convertedLinks: HTMLAnchorElement[] = [];

  elements.forEach(element => {
    if (!element) return;

    const offerId = element.dataset.offerId;

    if (!offerId) {
      console.warn('Элемент с data-offer-click найден, но data-offer-id отсутствует', element);
      return;
    }

    const linkElement = document.createElement('a');
    linkElement.href = `/market/r/${offerId}`;
    linkElement.target = '_blank';
    linkElement.rel = 'nofollow';

    // Копируем содержимое
    linkElement.innerHTML = element.innerHTML;

    // Копируем атрибуты
    Array.from(element.attributes).forEach(attr => {
      if (attr.name !== 'data-offer-click' && attr.name !== 'data-offer-id') {
        linkElement.setAttribute(attr.name, attr.value);
      }
    });

    // Заменяем элемент
    element.parentNode?.replaceChild(linkElement, element);
    convertedLinks.push(linkElement);
  });

  return convertedLinks;
}
